"use client";

import { useProjectDetail } from "@/app/[locale]/projects/_api/use-project-queries";
import { CertificateGrantCard } from "./certificate-grant-card";
import { FinancialSummary } from "./financial-summary";

export function CertificateGrantsAndFinancials({ projectId }: { projectId: string }) {
  const { data: projectDetail } = useProjectDetail(projectId);
  const charity = projectDetail?.charity;

  const grants = charity?.certificateGrants ?? [];
  const hasFinancials = charity?.totalIncome || charity?.fundraisingIncome || charity?.totalExpenses;

  if (grants.length === 0 && !hasFinancials) return null;

  return (
    <div className="space-y-4">
      {grants.length > 0 && (
        <div className="space-y-2">
          {grants.map((grant) => (
            <CertificateGrantCard key={grant.id} grant={grant} />
          ))}
        </div>
      )}
      <FinancialSummary
        totalIncome={charity?.totalIncome}
        fundraisingIncome={charity?.fundraisingIncome}
        totalExpenses={charity?.totalExpenses}
      />
    </div>
  );
}
